<script lang="ts">
    import clickSound from '@src/utils/useClickSound.js';

    let className = '';
    export let isModalButton = false;
    export let active = false;
    export let disabled = false;
    export { className as class };

    type ButtonVariant = 'primary' | 'secondary';
    type ButtonSize = 'medium' | 'large';

    export let variant: ButtonVariant = 'primary';
    export let size: ButtonSize = 'medium';

    let buttonStyles: string;

    let activeStyles: string;

    $: activeStyles = active && variant === 'secondary' ? 'bg-white text-button-label-active' : 'text-white';

    $: buttonStyles =
        variant === 'primary'
            ? 'bg-cross-bgrd-secnd hover:bg-white/[16%] active:bg-white/50'
            : 'bg-transparent border border-cross-n-400 hover:border-white active:border-white active:bg-white active:text-button-label-active';
    $: buttonStyles += size === 'medium' ? ' h-10' : ' h-16';
</script>

<button
    class="btn-base relative flex items-center justify-center rounded-2xl font-bold hover:cursor-pointer {buttonStyles} {activeStyles} {className}"
    {disabled}
    class:active
    use:clickSound={{
        sound: isModalButton ? 'audio_modal_open' : 'audio_basic_click'
    }}
    on:click
>
    <slot />
</button>
